"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _emotion = require("emotion");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var shapes = _interopRequireWildcard(require("../shapes"));

var utils = _interopRequireWildcard(require("../utils"));

var _ColumnHeader = _interopRequireDefault(require("../ColumnHeader"));

var _Document = _interopRequireDefault(require("../Document"));

var _RowHeader = _interopRequireDefault(require("../RowHeader"));

var _SelectAll = _interopRequireDefault(require("../SelectAll"));

var _SizedScrollSync = _interopRequireDefault(require("../SizedScrollSync"));

var _SheetControls = _interopRequireDefault(require("./SheetControls"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var gridRowStyle = (0, _emotion.css)(_templateObject(), colors.platinum);
var defaultColumnWidth = 150;
var firstColumnWidth = 50;
var rowHeight = 43;

function getDefaultColumnWidths(columns) {
  return columns.map(function () {
    return defaultColumnWidth;
  });
}

var Sheet =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Sheet, _PureComponent);

  function Sheet() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Sheet);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Sheet)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      columnWidths: getDefaultColumnWidths(_this.props.columns)
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "columnRef", (0, _react.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "controlRef", (0, _react.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "documentRef", (0, _react.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getContainerStyle", (0, _memoizeOne.default)(function (width, height) {
      return {
        width: width,
        height: height
      };
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rerenderKey", (0, _memoizeOne.default)(function () {
      return {};
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onGetColumnWidth", function (_ref) {
      var index = _ref.index;
      var columnWidths = _this.state.columnWidths;

      if (index < 0) {
        return defaultColumnWidth;
      }

      return columnWidths[index] || defaultColumnWidth;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onGetFirstColumnWidth", function () {
      return firstColumnWidth;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeColumn", function (columnIndex, width) {
      var columnWidths = _this.state.columnWidths;
      var newColumnWidths = columnWidths.slice();
      newColumnWidths.splice(columnIndex, 1, width);

      _this.setState({
        columnWidths: newColumnWidths
      }, function () {
        _this.columnRef.current.recomputeGridSize(columnIndex, 0);

        _this.documentRef.current.recomputeGridSize(columnIndex, 0);

        _this.controlRef.current.focus();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderInner", function (width, height, scrollSync) {
      var _this$props = _this.props,
          columns = _this$props.columns,
          dispatch = _this$props.dispatch,
          editing = _this$props.editing,
          rows = _this$props.rows,
          selection = _this$props.selection,
          readOnly = _this$props.readOnly;
      var columnWidths = _this.state.columnWidths;
      var scrollLeft = scrollSync.scrollLeft,
          scrollTop = scrollSync.scrollTop,
          onScroll = scrollSync.onScroll;

      var containerStyle = _this.getContainerStyle(width, height);

      return _react.default.createElement(_SheetControls.default, {
        ref: _this.controlRef,
        columns: columns,
        dispatch: dispatch,
        editing: editing,
        rows: rows,
        selection: selection,
        style: containerStyle,
        readOnly: readOnly
      }, _react.default.createElement("div", {
        className: gridRowStyle
      }, _react.default.createElement(_SelectAll.default, {
        rowHeight: rowHeight,
        onGetFirstColumnWidth: _this.onGetFirstColumnWidth
      }), _react.default.createElement(_ColumnHeader.default, {
        ref: _this.columnRef,
        columns: columns,
        dispatch: dispatch,
        rowHeight: rowHeight,
        rowCount: rows.length,
        selection: selection,
        scrollLeft: scrollLeft,
        width: width,
        onGetColumnWidth: _this.onGetColumnWidth,
        onGetFirstColumnWidth: _this.onGetFirstColumnWidth,
        onResizeColumn: _this.onResizeColumn
      })), _react.default.createElement("div", {
        className: gridRowStyle
      }, _react.default.createElement(_RowHeader.default, {
        columnCount: columns.length,
        dispatch: dispatch,
        height: height,
        rowHeight: rowHeight,
        rows: rows,
        scrollTop: scrollTop,
        selection: selection,
        onGetFirstColumnWidth: _this.onGetFirstColumnWidth
      }), _react.default.createElement(_Document.default, {
        ref: _this.documentRef,
        columns: columns,
        columnWidths: columnWidths,
        dispatch: dispatch,
        editing: editing,
        height: height,
        rowHeight: rowHeight,
        rows: rows,
        selection: selection,
        width: width,
        onGetColumnWidth: _this.onGetColumnWidth,
        onGetFirstColumnWidth: _this.onGetFirstColumnWidth,
        onScroll: onScroll,
        readOnly: readOnly
      })));
    });
    return _this;
  }

  (0, _createClass2.default)(Sheet, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var editing = this.props.editing;

      if (utils.isEditing(prevProps.editing) && !utils.isEditing(editing)) {
        this.controlRef.current.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          editing = _this$props2.editing,
          rows = _this$props2.rows,
          selection = _this$props2.selection;
      return _react.default.createElement(_SizedScrollSync.default, {
        height: 600,
        rerenderKey: this.rerenderKey(editing, rows, selection)
      }, this.renderInner);
    }
  }]);
  return Sheet;
}(_react.PureComponent);

exports.default = Sheet;
(0, _defineProperty2.default)(Sheet, "propTypes", {
  columns: _propTypes.default.arrayOf(shapes.column).isRequired,
  dispatch: _propTypes.default.func.isRequired,
  editing: shapes.editing.isRequired,
  rows: _propTypes.default.arrayOf(shapes.row).isRequired,
  selection: shapes.selection,
  onChange: _propTypes.default.func,
  readOnly: _propTypes.default.bool.isRequired
});